import { render } from "./ListEvents.vue?vue&type=template&id=53911c4d"
import script from "./ListEvents.vue?vue&type=script&lang=js"
export * from "./ListEvents.vue?vue&type=script&lang=js"

import "./ListEvents.vue?vue&type=style&index=0&id=53911c4d&lang=less"
script.render = render

export default script